const styles = {
  segment: {
    justifyContent: 'space-around'
  },
  label: {
    marginLeft: '10px'
  },
  checkbox: {
    display: 'flex',
    alignItems: 'center'
  },
  disabled: {
    opacity: 0.5,
    pointerEvents: 'none'
  },
  notAvailable: {
    fontWeight: 'bold'
  }
}

export default styles
